<template>
    <div class="d-flex justify-content-between my-3">
        <router-link class="back-route h3" to="" @click="$router.go(-1)">
            <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
            Model Answers
        </router-link>

    </div>
    <div class="content">
        <div>
            <div class="d-flex justify-content-start gap-2 align-items-center content-border">
                <label for="q-weight">Weight Per Question</label>
                <input id="q-weight" autocomplete="off" type="number" min="0" class="weight-style" :value="weight"/>
            </div>

            <div class=" d-flex flex-column justify-content-center align-items-start content-border">
                <h6>Name</h6>
                <p>{{template['name']}}</p>
            </div>

            <div class=" d-flex flex-column justify-content-center align-items-start content-border">
                <h6>Description</h6>
                <p class="description-container">{{template['description']}}</p>
            </div>

            <div class=" d-flex flex-column justify-content-center align-items-start content-border">
                <h6>Questions Types</h6>
                <div class="d-flex gap-4">
                    <span v-for="type in questionsTypes">{{type}}</span>
                </div>

            </div>
        </div>
        <QuestionsComponent @weight="onWeight" :template="template"/>
    </div>
</template>

<script>
    import {onMounted, ref} from "vue";
    import repository from "../../../api-services/repository";
    import {useRoute} from "vue-router";
    import QuestionsComponent from "../../pages/template/commonCoponents/questions";
    import getQuestionType from "../../../helpers/getQuestionType";
    import getQuestionName from "../../../helpers/getQuestionName";
    import router from "../../../router";
    import {useStore} from "vuex";

    export default {
        name: 'app',
        components: {QuestionsComponent},
        setup() {
            const store = useStore();
            const route = useRoute();
            const template = ref({
                name: '',
                description: '',
                questions: {
                    trueOrFalse: {
                        weight: 0,
                        title:'True Or False',
                        questions: [

                        ],
                    },
                    multipleChoices: {
                        weight: 0,
                        title:'Multiple Choice',
                        questions: [
                        ]
                    },
                    freeText: {
                        weight: 0,
                        title:'Free Text',
                        questions: [

                        ],
                    },
                    slides: {
                        weight: 0,
                        title:"Slides",
                        name: '',
                        description: '',
                        images: [],
                        category: []
                    },
                    rank: {
                        weight: 0,
                        title:'Rank',
                        questions: [

                        ],
                    },
                    arrange: {
                        weight: 0,
                        title:'Arrange',
                        questions: [

                        ],
                    },
                }
            });

            const questionsTypes = ref([]);
            const weightFlag = ref(false);
            const types = ref([]);
            const weight = ref(0);
            const templateId = route.params.id;

            onMounted(async () => {
                try {
                    let templateData = await repository.view('templates', templateId);
                    console.log({templateData})
                    await formatData(templateData.data.data);

                    await types.value.forEach((item) => {
                        if(item !== 'slides' &&  template.value.questions[item]['questions'].length > 0){

                            if(!weightFlag.value){
                                weight.value = template.value.questions[item].weight;
                                weightFlag.value = true
                            }
                        }else if(item === 'slides'){

                            if(!weightFlag.value){
                                weight.value = template.value.questions[item].weight;
                                weightFlag.value = true
                            }
                        }

                    })

                } catch (e) {
                    if (process.env.VUE_APP_ENV === 'development')
                        console.log({e})
                }
            });

            const formatData = (data) => {
                let type = null;
                let qName = null;

                data.questions.forEach((q) => {

                    // if (questionsTypes.value.indexOf(q.title) === -1) {
                    //     questionsTypes.value.push(q.title);
                    // }

                    type = getQuestionType(q.type);
                    qName = getQuestionName(q.type);

                    if(!questionsTypes.value.includes(qName))
                        questionsTypes.value.push(qName)

                    template.value.questions[type].questions = [];
                });

                template.value.name = data.name;
                template.value.description = data.description;

                data.questions.forEach((q) => {
                    type = getQuestionType(q.type);
                    template.value.questions[type].weight = q.weight;
                    template.value.questions[type].title = q.title;

                    q.answers.forEach((ans) => {
                        ans.is_correct = ans.is_correct === 1;
                    });

                    if (type !== 'freeText') {
                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answers: q.answers
                            }
                        )
                    } else {
                        template.value.questions[type].questions.push(
                            {
                                question: q.content,
                                answer: q.answers[0].value,
                            }
                        )
                    }
                });

                data.slides.forEach((slide) => {

                    // if(!questionsTypes.value.includes('Slides'))
                    //     questionsTypes.value.push('Slides')

                    questionsTypes.value.push(slide.title);

                    template.value.questions['slides'].weight = slide.weight;
                    template.value.questions['slides'].title = slide.title;
                    template.value.questions['slides'].name = slide.name;
                    template.value.questions['slides'].description = slide.description;
                    template.value.questions['slides'].images = slide.attachments;
                    template.value.questions['slides'].category = slide.categories;
                })

                if (process.env.VUE_ENV === 'development')
                    console.log('temp => ', template.value)
            };

            const onWeight = (e) => {
                weight.value = e;
                if (process.env.VUE_ENV === 'development')
                    console.log({e});
            };

            const backHandler = async () => {
                await router.push('/' + store.state.settings.currentRoute);
            };

            return {
                template,
                questionsTypes,
                weight,
                weightFlag,
                types,
                formatData,
                onWeight,
                backHandler
            }
        }
    }
</script>

<style scoped>

    #q-weight{
        pointer-events: none;
    }
    .description-container {
        height: 150px;
        overflow-y: auto;
    }

    .content-border {
        padding-bottom: 10px;
        padding-top: 10px;
        border-bottom: 1px solid #6F8896;
    }

    .content-border:last-child {
        border-bottom: none;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 30px;
        height: 85vh;
        overflow-y: auto;
        border-top: none;
        background-image: linear-gradient(#16303a, #021A24);
        border-radius: 20px;
    }


    .weight-style {
        background-color: transparent;
        border: 1px solid #39525C;
        border-radius: 4px;
        width: 86px;
        height: 32px;
        color: #FFF;
        padding: 10px;
    }


    textarea {
        height: 200px;
        min-height: 200px;
        max-height: 250px;
    }
</style>